<template>
	<div id="cardsProfile" class="section">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<div class="container">
			<b-collapse class="breathe-sm is-clear" aria-id="Profile" :open="true" animation="slide">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="Profile">
					<p v-if="user.FirstName && user.LastName">
						{{ user.FirstName }} {{ user.LastName }}
					</p>
					<p v-if="!user.FirstName && !user.LastName">
						{{ user.FirstName }} {{ user.LastName }}
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="full-breathe">
						<div class="columns">
							<div class="column">
								<img v-if="user.PhotoSrc != null" @error="user.PhotoSrc = null" :src="$BSDB_API + user.PhotoSrc">
								<img v-if="user.PhotoSrc == null" src="/silhouette.png">
							</div>
							<div class="column">
								<div class="breathe-sm" v-if="user.EmploymentHistory">
									<b>Current/Most Recent Position</b>
									<div v-if="currentEmployment">
										<span>{{currentEmployment.JobTitle}} at <a target="_blank" :href="'https://google.com/search?q=' + encodeURI(currentEmployment.Company)">{{currentEmployment.Company}}</a></span>
										<p v-if="$store.getters.showCompensation && !$store.getters.hideCompensation"><span v-html="$currency.range(currentEmployment.Compensation)"></span></p>
										<p v-html="duration(currentEmployment.StartDate, currentEmployment.EndDate)"></p>
									</div>
								</div>
								<div class="breathe-sm" v-if="user.TargetCompensation != null">
									<b>Expected Compensation</b>
									<p><span v-html="$currency.range(user.TargetCompensation)"></span></p>
								</div>
								<div class="breathe-sm">
									<b>Work Authorizations</b>
									<div v-for="w in user.WorkAuthorizations">
										<span>{{w}}</span>
									</div>
								</div>
							</div>
							<div class="column">
								<div class="breathe-sm">
									<a :href="'mailto:' + user.Email">{{user.Email}}</a>
									<p v-if="user.Phone">{{user.Phone}}</p>
								</div>
								<div class="breathe-sm">
									<b>Language Proficiencies</b>
									<div v-for="l in user.Languages">
										<span>{{l}}</span>
									</div>
								</div>
								<div class="breathe-sm" v-if="user.Demographic">
									<div v-if="user.Demographic.Gender && user.Demographic.Gender !== 'Decline to answer'">
										<b>Gender</b>
										<div>
											{{user.Demographic.Gender}}
										</div>
									</div>
									<div v-if="!(!user.Demographic.HasEthnicity && (!user.Demographic.Ethnicity || user.Demographic.Ethnicity == 'Decline to answer'))">
										<b>Underrepresented Race/Ethnicity</b>
										<div>
											{{user.Demographic.HasEthnicity ? 'Yes' : 'No'}}<span v-if="user.Demographic.Ethnicity">, {{user.Demographic.Ethnicity}}</span>
										</div>
									</div>
									<div v-if="MinorityGroup.length > 0">
										<b>Additional Underrepresented Group</b>
										<div>
											{{MinorityGroup.join(', ')}}
										</div>
									</div>
								</div>
								<div class="breathe-sm">
									<b>Additional Information:</b>
									<div>
										<span v-for="l in SocialLinks">
											<a :href="l.Url" target="_blank">
												<span v-if="l.Name === '_linkedin'">
													<img :src="require('@/assets/images/linkedin.png')" class="my-2" style="max-width:65px; padding-left: 0; padding-right:5px" />
												</span>
												<span v-if="l.Name === '_facebook'">
													<img :src="require('@/assets/images/facebook.png')" class="my-2" style="max-width:65px; padding-left: 0; padding-right:5px" />
												</span>
												<span v-if="l.Name === '_twitter'">
													<img :src="require('@/assets/images/twitter.png')" class="my-2" style="max-width:65px; padding-left: 0; padding-right:5px" />
												</span>
											</a>
										</span>
									</div>
									<div v-for="l in Links">
										<a :href="l.Url" target="_blank">{{l.Name}}</a>
									</div>
									<div>
										<a class="btn cta-yellow" style="text-decoration: none; padding: 10px;" :href="'mailto:' + this.user.Email">Contact</a>
									</div>
								</div>
							</div>
							<div class="column">
								<div class="my-4">
									<b-button class="button is-grey" :loading="findingSimilar" :disabled="findingSimilar" @click="findSimilar(user)">Find Similar Candidates</b-button>
								</div>
								<div class="my-4">
									<b-tooltip position="is-bottom" :triggers="['hover']" :auto-close="['outside', 'escape']" type="is-light">
										<b-button class="button is-grey" @click="flagUser('337ab7')"><i :class="[isFlagged ? 'fas' : 'far', 'fa-flag']" :style="(isFlagged == true) ? flagStyle : 'color: black'"></i>Flag Profile</b-button>
										<template v-slot:content>
											<div class="flags">
												<i class="clickable fa fa-flag" style="color:#337ab7" @click="flagUser('337ab7')"></i>&nbsp;
												<i class="clickable fa fa-flag" style="color:#ff0000" @click="flagUser('ff0000')"></i>&nbsp;
												<i class="clickable fa fa-flag" style="color:#0aba00" @click="flagUser('0aba00')"></i>&nbsp;
												<i class="clickable fa fa-flag" style="color:#4800e4" @click="flagUser('4800e4')"></i>&nbsp;
												<i class="clickable fa fa-flag" style="color:#ff6a00" @click="flagUser('ff6a00')"></i>
												<i class="clickable fa fa-times" style="color:red" @click="flagUser('')"></i>
											</div>
										</template>
									</b-tooltip>
								</div>
								<div class="my-4">
									<b-button class="button is-grey" @click="downloadDocument(user.PrimaryResumeKey, user.PrimaryResumeName, user.FirstName + 's Resume')">Download Resume</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
			<b-collapse class="breathe-sm is-clear" aria-id="ExecutiveBio" :open="false">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="ExecutiveBio">
					<p>
						Executive Biography
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="content full-breathe" v-if="user.Bio">
						<div v-html="user.Bio"></div>
					</div>
				</div>
			</b-collapse>
			<b-collapse class="breathe-sm is-clear" aria-id="CareerHistory" :open="false">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="CareerHistory">
					<p>
						Career History
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="full-breathe">
						<div class="columns is-multiline">
							<div class="column is-one-third" v-for="e in employments">
								<div class="card" style="padding: 20px">
									<p class="breathe-sm"><strong><a target="_blank" :href="'https://google.com/search?q=' + encodeURI(e.Company)">{{e.Company}}</a></strong></p>
									<p class="breathe-sm">{{e.JobTitle}}</p>
									<p class="breathe-sm">{{e.JobFunction}}</p>
									<p class="breathe-sm" v-if="($store.getters.showCompensation && !$store.getters.hideCompensation) && e.Compensation != null"><span v-html="$currency.range(e.Compensation)"></span></p>
									<p class="breathe-sm">{{e.Industry}}</p>
									<p class="breathe-sm">{{e.Country}}</p>
									<p class="breathe-sm">
										<b-field>
											<template slot="label">
												{{duration(e.StartDate, e.EndDate)}}
											</template>
											<template slot="message">
												Start Date: {{e.StartDate | moment("M/D/YYYY")}}
												<div v-if="e.EndDate">End Date: {{e.EndDate | moment("M/D/YYYY")}}</div>
												<div v-else>Currently Employed</div>
											</template>
										</b-field>
									</p>
								</div>
							</div>
						</div>
						<div></div>
					</div>
				</div>
			</b-collapse>
			<b-collapse class="breathe-sm is-clear" aria-id="Education" :open="false">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="Education">
					<p>
						Education / Professional Organizations
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="full-breathe">
						<div v-if="user.Degrees">
							<p class="breathe-md"><b>Degrees</b></p>
							<div class="columns is-multiline">
								<div class="column is-one-third" v-for="d in user.Degrees">
									<div class="card" style="padding: 20px">
										<p class="breathe-sm">{{d.Name}}</p>
										<p class="breathe-sm">{{d.Institution}}</p>
										<p class="breathe-sm">{{d.Location}}</p>
										<p class="breathe-sm">{{d.Date | moment('MM/DD/YYYY')}}</p>
									</div>
								</div>
							</div>
						</div>
						<div v-if="user.Certificates" class="is-clear">
							<p class="breathe-md"><b>Certificates</b></p>
							<div class="columns is-multiline">
								<div class="column is-one-third" v-for="c in user.Certificates">
									<div class="card" style="padding: 20px">
										<p class="breathe-sm">{{c.Name}}</p>
										<p class="breathe-sm">{{c.Institution}}</p>
										<p class="breathe-sm">{{c.Location}}</p>
										<p class="breathe-sm">{{c.Date | moment('MM/DD/YYYY')}}</p>
									</div>
								</div>
							</div>
						</div>
						<div v-if="user.Organizations" class="is-clear">
							<p class="breathe-md"><b>Organizations</b></p>
							<div v-for="c in user.Organizations">
								<a :href="c.Url" target="_blank">{{c.Name}}</a>
							</div>
						</div>
						<div v-if="user.Languages" class="is-clear">
							<p class="breathe-md"><b>Languages</b></p>
							<div v-for="l in user.Languages">
								{{l}}
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
			<b-collapse class="breathe-sm is-clear" aria-id="Resume" :open="false">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="Resume">
					<p>
						Resume/CV and Career Documents
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="full-breathe">
						<b>Resume</b>
						<iframe :src="user.ResumeURL" style="width: 100%; border: 0; height: 800px; padding: 10px;"></iframe>
						<br />
						<b>Other Documents:</b>
						<div v-for="document in user.Documents">
							<a @click="downloadDocument(document.S3Key, document.Name)">{{ document.Name }}</a>
						</div>
					</div>
				</div>
			</b-collapse>
			<b-collapse class="breathe-sm is-clear" aria-id="Seeking" :open="false">
				<div slot="trigger"
					 class="message-header has-medium-blue-background"
					 role="button"
					 aria-controls="Seeking">
					<p>
						Seeking
					</p>
				</div>
				<div class="has-light-grey-background">
					<div class="full-breathe">
						<div class="columns">
							<div class="column" v-if="user.TargetFunctions">
								<p class="small-font"><b>Functions</b></p>
								<p class="small-font" v-for="f in user.TargetFunctions">{{f}}</p>
							</div>
							<div class="column" v-if="user.TargetIndustries">
								<p class="small-font"><b>Industries</b></p>
								<p class="small-font" v-for="i in user.TargetIndustries">{{i}}</p>
							</div>
							<div class="column" v-if="user.TargetCompensation">
								<p class="small-font"><b>Compensation</b></p>
								<p class="small-font"><span v-html="$currency.range(user.TargetCompensation)"></span></p>
							</div>
							<div class="column" v-if="user.TargetCountries">
								<p class="small-font"><b>Country</b></p>
								<p class="small-font" v-for="w in user.TargetCountries">{{w}}</p>
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
		</div>
	</div>
</template>

<script>
	import moment from "moment";

	export default {

		props: {
			id: String
		},
		data() {
			return {
				user: [],
				api: process.env.VUE_APP_BSDB_API,
				isLoading: false,
				findingSimilar: false,
				showFlags: false,
				isFlagged: false,
				flagColor: ""
			}
		},
		computed: {
			MinorityGroup() {
				if (this.user && this.user.Demographic && this.user.Demographic.MinorityGroup) {
					try {
						return JSON.parse(this.user.Demographic.MinorityGroup);
					}
					catch (err) { return []; }
				}
				else
					return [];
			},
			SocialLinks() {
				if (this.user && this.user.Links) {
					return this.user.Links.filter(x => ["_linkedin", "_facebook", "_twitter"].some(y => y === x.Name));
				}
				else
					return [];
			},
			Links() {
				if (this.user && this.user.Links) {
					return this.user.Links.filter(x => !["_linkedin", "_facebook", "_twitter"].some(y => y === x.Name));
				}
				else
					return [];
			},
			currentEmployment() {
				if (this.user.EmploymentHistory.length == 0)
					return {};
				else {
					var history = this.user.EmploymentHistory.slice(0);
					history.sort((a, b) => {

						if (a.IsCurrentlyEmployed != b.IsCurrentlyEmployed)
							return a.IsCurrentlyEmployed < b.IsCurrentlyEmployed ? 1 : -1;
						else if (a.IsCurrentlyEmployed == b.IsCurrentlyEmployed && a.IsCurrentlyEmployed == 1)
							return a.StartDate > b.StartDate ? 1 : -1;

						return a.EndDate < b.EndDate ? 1 : -1;
					});

					return history[0];
				}
			},
			employments() {
				if (!this.user.EmploymentHistory)
					return [];

				var history = this.user.EmploymentHistory.slice(0);
				return history.sort((a, b) => {
					if (a.IsCurrentlyEmployed != b.IsCurrentlyEmployed)
						return a.IsCurrentlyEmployed < b.IsCurrentlyEmployed ? 1 : -1;
					else if (a.IsCurrentlyEmployed == b.IsCurrentlyEmployed && a.IsCurrentlyEmployed == 1)
						return a.StartDate > b.StartDate ? 1 : -1;

					return a.EndDate < b.EndDate ? 1 : -1;
				});
			},
			flagStyle() {
				if (this.isFlagged == true) {
					return "color: #" + this.flagColor + "!important";
				}
				else {
					return "color: black";
				}
			}
		},
		async created() {
			var profiles = this.$store.getters.flagged;

			//console.log(profiles.flagged);
			if (profiles && profiles.flagged && profiles.flagged.length > 0) {
				profiles.flagged.forEach(p => {
					if (p.UserId == this.id) {
						this.isFlagged = true;
						this.flagColor = p.Color;
					}
				})
			}

			this.isLoading = true;
			if (this.$store.getters.queryId) {
				this.$http.post('api/user/' + this.id + '/view', { queryId: this.$store.getters.queryId });
			}
			await this.$http.get('api/user/' + this.id)
				.then(async resp => {
					this.user = resp.data;
					if (resp.data.PrimaryResumeKey != null && resp.data.PrimaryResumeKey != "") {
						this.user.ResumeURL = '/pdf/web/viewer.html?file=' + encodeURIComponent(this.api + 'api/user/document/' + resp.data.PrimaryResumeKey + '/previewer');
					}
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
					this.$buefy.toast.open({ message: "Error loading this profile", type: "is-danger" });
				})
		},
		methods: {
			flagUser(color) {
				this.$http.post("api/profile/flag/" + this.id, { Color: color })
					.then(resp => {
						if (resp.data == true) {
							this.$buefy.toast.open("User flagged");
							this.isFlagged = true;
							this.flagColor = color;
						}
						else {
							this.$buefy.toast.open("User flag removed");
							this.isFlagged = false;
							this.flagColor = color;
						}
						this.$http.get("api/profile/flagged")
							.then(resp => {
								if (resp.data.flagged.length > 0) {
									this.$store.dispatch('setFlaggedProfiles', resp.data);
								}
							}).catch(err => {
								console.log(err);
							})
					}).catch(err => {
						console.log(err);
					})
			},
			goToLink(url) {
				window.location.href = url;
			},
			duration(start, end) {
				if (start == null && end == null)
					return;
				start = start || new Date();
				end = end || new Date();

				var s = moment(start);
				var e = moment(end);
				var months = e.diff(s, 'months');
				if (months < 12)
					return months + ' months';
				else {
					var years = Math.floor(months / 12);
					var y = (years > 1) ? 'years' : 'year';
					months %= 12;
					var m = (months > 1) ? 'months' : 'month'
					var rtn = '';
					if (years > 0)
						rtn += years + ' ' + y;
					if (years > 0 && months > 0)
						rtn += ', ';
					if (months > 0)
						rtn += months + ' ' + m;

					return rtn;
				}
			},
			findPos(obj) {
				return obj.offsetTop;
			},
			error: function (err) {
				console.log(err);
			},
			async downloadDocument(S3Name, Title, newTitle) {
				try {
					this.downloading = true;
					var re = /(?:\.([^.]+))?$/;
					var resp = await this.$http({ method: 'get', url: 'api/user/document/' + S3Name, responseType: 'arraybuffer' });
					var blob;

					if (re.exec(Title)[0] == ".pdf") {
						blob = new Blob([resp.data], { 'type': 'application/pdf' });
					} else if (re.exec(Title)[0] == ".doc") {
						blob = new Blob([resp.data], { 'type': 'application/msword' });
					} else if (re.exec(Title)[0] == ".docx") {
						blob = new Blob([resp.data], { 'type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
					}
					else
						blob = new Blob([resp.data], { 'type': 'application/octet-stream' });

					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);

					if (re.exec(Title)[0] == ".pdf") {
						link.setAttribute('download', newTitle || Title + '.pdf');
					} else if (re.exec(Title)[0] == ".doc") {
						link.setAttribute('download', newTitle || Title + '.doc');
					} else if (re.exec(Title)[0] == ".docx") {
						link.setAttribute('download', newTitle || Title + '.docx');
					}
					else
						link.setAttribute('download', newTitle || Title + '.pdf'); //We can try and 'assume' it's a pdf because we always try to convert to this.

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.downloading = false;
				}
				catch (err) {
					this.downloading = false;
					this.$buefy.toast.open({ message: "Error downloading the document", type: "is-danger" });
					console.error(err);
				}
			},
			async findSimilar(user) {
				if (user.PrimaryResumeKey) {
					try {
						this.findingSimilar = true;
						var response = await this.$http.get("api/user/document/" + user.PrimaryResumeKey + "/extractions");
						var query = JSON.parse(JSON.stringify(this.$emptyQuery));
						query.Resume = response.data.Extraction;
						sessionStorage.removeItem("BSDBResults");
						this.findingSimilar = false;
						this.$store.dispatch("setQuery", query);
						this.$store.dispatch("setQueryId", null);
						this.$router.push("/results");
					}
					catch (err) {
						this.findingSimilar = false;
						console.error(err);
						this.$buefy.toast.open({ message: "Error running similar", type: "is-danger" });
					}
				}
				else {
					this.$buefy.toast.open({ message: "No primary resume.", type: "is-warning" });
				}
			}
		}
	}

</script>

<style>


	#cardsProfile .card-header-title {
		background: #0d6db6;
		color: white !important;
	}

	/*flag color selector menu*/
	#cardsProfile .menu {
		position: absolute;
		width: auto;
		background: #dbdbdb;
		overflow: hidden;
		text-align: center;
		opacity: 0;
		border: solid 1px black;
		margin-left: 50px;
		visibility: hidden;
	}

	#cardsProfile .menu-show {
		opacity: 1;
		visibility: visible;
	}

	#cardsProfile i.fa-flag, div i.fa-flag-o {
		margin: 5px;
	}

		#cardsProfile i.fa-flag.clickable:hover, i.fa-flag-o.clickable:hover {
			cursor: pointer;
			opacity: 0.7;
		}
</style>
